import React, { useEffect, useState } from "react";
import { Row, Col, Steps, Input, Popover, Button, message } from "antd";
import moment from "moment";
import media from "../../../media";
import CardHeader from "../../../components/atoms/cardHeader";
import { ShipmentHistory } from "../../../components/molecules/ShipmentHistory";
import { PrintInvoice } from "../../../components/molecules/PrintInvoice";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  ApproveOrderThunk,
  OrderChangeStatusThunk,
  OrderShipmentHistoryThunk,
  WayuvegaThunk,
} from "../../../store/thunks/orderThunk";
import { ContentInputField } from "../../../components/atoms/formFields/inputField/contentInputField";

export const Shipment = ({
  mainOrderId,
  overview,
  data,
  orderBar,
  orderId,
}) => {
  const { Step } = Steps;
  const dispatch = useDispatch();

  const { data: shipping } = useSelector((state) => state.orderShipping);
  const { data: wayuvegaList } = useSelector((state) => state.wayuvega);
  const { data: ApproveOrder } = useSelector((state) => state.approveOrder);

  const { data: shippingHistory } = useSelector(
    (state) => state.shipmentHistory,
  );
  // Declaring Popover
  const customDot = (dot) => <Popover>{dot}</Popover>;
  const [popup, setPopup] = useState(false);
  const [reason, setReason] = useState("");
  const [cancellationRemark, setCancellationRemark] = useState(false);
  const [remarks, showRemarks] = useState("");
  const [addclass, setAddclass] = useState(false);
  const [page, setPage] = useState(true);
  const [wayu, setWayu] = useState("");
  const [creationLoading, setCreationLoading] = useState(false);

  const [errors, setErrors] = useState();
  const [formState, setFormState] = useState({
    orderRefId: mainOrderId,
    deliveryMode: "SELF",
  });
  const OrderStatus = data?.shippingInformation?.orderStatus;

  const BloodSampleDiagnostics = overview?.orderItem?.some(
    (item) => item.productDomainCategory?.en === "Blood & Sample Diagnostics",
  );

  useEffect(() => {
    if (OrderStatus === "SHIPMENT_CANCELLED") {
      setAddclass(false);

      setFormState((prev) => ({
        orderRefId: prev.orderRefId,
        weight: prev.weight,
        height: prev.height,
        width: prev.width,
        breadth: prev.breadth,
        deliveryMode: "SELF",
        externalDeliveryMode: null,
      }));
    }
  }, [OrderStatus]);

  const condition =
    ((OrderStatus === "OUT_FOR_DELIVERY" ||
      OrderStatus === "PROCESSING" ||
      OrderStatus === "ACCEPTED" ||
      OrderStatus === "RTO_INITIATED" ||
      OrderStatus === "RTO_IN_TRANSIT" ||
      OrderStatus === "RTO_DELIVERED" ||
      OrderStatus === "DAMAGED" ||
      OrderStatus === "LOST" ||
      OrderStatus === "SHIPPED" ||
      overview?.orderStatus === "RTO_INITIATED") &&
      formState?.deliveryMode === "SELF") ||
    (formState?.deliveryMode === "EXTERNAL" &&
      (OrderStatus === "ACCEPTED" || OrderStatus === "PROCESSING")) ||
    formState?.deliveryMode === "";
  const [externalData, setExternalData] = useState({
    orderStage: "SHIPPED",
    orderRefID: mainOrderId,
    remarks: "Testing",
  });

  const isShipmentCancelled = overview?.orderItem?.[0]?.isShipmentCancelled;
  const AdminCancelledStatus = shippingHistory?.some(
    (item) => item?.status === "CANCELLED_BY_SELLER",
  );

  const CourierCancelledStatus = shippingHistory?.some(
    (item) => item?.status === "CANCELLED",
  );

  useEffect(() => {
    setPage(false);

    if (OrderStatus === "SHIPMENT_CANCELLED") {
      return; // prevent overriding SELF
    }
    const newConditon =
      shipping?.shippingInformation?.deliveryMode === "EXTERNAL" ||
      shipping?.shippingInformation?.externalDeliveryMode ===
        "IN_HOUSE_SERVICE_SERVICE";
    setAddclass(newConditon);
    setFormState({
      ...formState,
      deliveryMode: shipping?.shippingInformation?.deliveryMode
        ? shipping?.shippingInformation?.deliveryMode
        : shipping?.shippingInformation?.orderStatus === "PROCESSING" ||
            shipping?.shippingInformation?.orderStatus === "ACCEPTED"
          ? ""
          : "SELF",
    });
  }, [data]);

  useEffect(() => {
    if (!orderId || !mainOrderId) return;

    dispatch(
      OrderShipmentHistoryThunk({
        orderRefID: mainOrderId,
        id: orderId,
      }),
    );
  }, [orderId, mainOrderId, dispatch]);

  useEffect(() => {
    if (ApproveOrder) {
      setCreationLoading(false);
      setFormState({});
    }
  }, [ApproveOrder]);
  useEffect(() => {
    if (overview?.orderStatus === "CANCELLED") return;
    // if (OrderStatus !== "CANCELLED") {
    dispatch(
      WayuvegaThunk({
        orderRefId: mainOrderId,
        shippingPartner: "WAYUVEGA",
      }),
    );
    // }
  }, []);
  return (
    <>
      {page ? (
        <div className="align-items-center d-flex font-weight-bolder h-200px justify-content-center">
          No Order Found With Respect To The Shipment
        </div>
      ) : (
        <>
          <div className="steps">
            <Row gutter={[30, 30]} className="mt-5 mb-10">
              <Col className="gutter-row" xs={24}>
                <Steps
                  current={orderBar?.length}
                  progressDot={customDot}
                  className="custom-steps"
                >
                  {orderBar &&
                    orderBar.map((orderStatus, index) => {
                      return (
                        <>
                          <Step
                            title={
                              <>
                                <span className="d-block">
                                  {orderStatus?.orderStage === "SHIPPED"
                                    ? "IN-TRANSIT"
                                    : orderStatus?.orderStage}
                                </span>
                                <span
                                  className="font-size-sm d-block"
                                  style={{ fontSize: "11px" }}
                                >
                                  {moment
                                    .utc(orderStatus?.date)
                                    .local()
                                    .format("DD-MM-YYYY hh:mm A")}
                                </span>
                              </>
                            }
                          />
                        </>
                      );
                    })}
                </Steps>
              </Col>
            </Row>
          </div>

          {(OrderStatus === "PICKED_READY_FOR_SHIPPED" ||
            isShipmentCancelled) && (
            <div className="card card-custom mb-5">
              {AdminCancelledStatus && (
                <div
                  class="alert alert-custom alert-outline-warning bg-warning-o-30 fade mb-5 p-3 pl-5 show"
                  role="alert"
                >
                  <div class="alert-icon">
                    <i class="flaticon-warning"></i>
                  </div>
                  <div class="alert-text font-size-lg text-dark">
                    <p className="text-dark">
                      Shipment has been cancelled by Admin.
                    </p>
                  </div>
                </div>
              )}
              {CourierCancelledStatus && (
                <div
                  class="alert alert-custom alert-outline-warning bg-warning-o-30 fade mb-5 p-3 pl-5 show"
                  role="alert"
                >
                  <div class="alert-icon">
                    <i class="flaticon-warning"></i>
                  </div>
                  <div class="alert-text font-size-lg text-dark">
                    <p className="text-dark">
                      Shipment has been cancelled by Courier Partner .
                    </p>
                  </div>
                </div>
              )}

              <CardHeader name={"Set Shipping Model"} />
              <div className="border border-1 border-light-dark border-top-0 card-body font-weight-bolder p-10">
                <Row gutter={[20, 20]}>
                  <Col
                    className="gutter-row text-right font-size-lg"
                    xs={24}
                    lg={6}
                  >
                    Shipping Model:
                  </Col>

                  {!BloodSampleDiagnostics && (
                    <>
                      <Col className="gutter-row fsfdsfdsfss" xs={24} lg={18}>
                        <label className="radio">
                          <input
                            type="radio"
                            name="radios2"
                            onChange={(e) => {
                              if (e.target.checked) {
                                setAddclass(true);
                                message.info(
                                  "Please select a courier partner to proceed.",
                                );
                                setFormState({
                                  ...formState,
                                  externalDeliveryMode:
                                    "EXTERNAL_DISTRIBUTOR_SERVICE",
                                  deliveryMode: "EXTERNAL",
                                });
                              }
                            }}
                          />
                          <span className="mr-5"></span>
                          <p className="m-0">
                            Courier Service by Delivery Partner{" "}
                            <span className="d-block font-size-xs font-weight-normal text-muted">
                              We offer reliable courier services through
                              Shiprocket. Your items will be shipped safely to
                              your customers.
                            </span>
                          </p>
                        </label>
                        {formState?.externalDeliveryMode ===
                        "EXTERNAL_DISTRIBUTOR_SERVICE" ? (
                          <>
                            <div className="d-flex align-item-center">
                              <label className="radio mt-5 ml-5">
                                <input
                                  type="radio"
                                  name="radio21"
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setAddclass(true);
                                      setFormState({
                                        ...formState,
                                        shippingPartner: "WAYUVEGA",
                                      });
                                    }
                                  }}
                                />
                                <span className="mr-5"></span>
                                <p className="m-0">Wayuvega</p>
                              </label>{" "}
                              <label className="radio mt-5 ml-5">
                                <input
                                  type="radio"
                                  name="radio21"
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setAddclass(true);
                                      setFormState({
                                        ...formState,
                                        shippingPartner: "DELHIVERY_ONE",
                                      });
                                    }
                                  }}
                                />
                                <span className="mr-5"></span>
                                <p className="m-0">Delhivery One</p>
                              </label>{" "}
                              <label className="radio mt-5 ml-5">
                                <input
                                  type="radio"
                                  name="radio21"
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setAddclass(true);
                                      setFormState({
                                        ...formState,
                                        shippingPartner: "PRO_SHIP",
                                      });
                                    }
                                  }}
                                />
                                <span className="mr-5"></span>
                                <p className="m-0">Pro Ship</p>
                              </label>{" "}
                              <label className="radio mt-5 ml-5 mr-2">
                                <input
                                  type="radio"
                                  name="radio21"
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setAddclass(true);
                                      setFormState({
                                        ...formState,
                                        shippingPartner: "EKART",
                                      });
                                    }
                                  }}
                                />
                                <span className="mr-5"></span>
                                <p className="m-0">E-kart</p>
                              </label>{" "}
                              <label className="radio mt-5">
                                <input
                                  type="radio"
                                  name="radio21"
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setAddclass(true);
                                      setFormState({
                                        ...formState,
                                        shippingPartner: "SHIP_ROCKET",
                                      });
                                    }
                                  }}
                                />
                                <span className="mr-5"></span>
                                <p className="m-0">Ship rocket </p>
                              </label>
                            </div>
                            {formState?.shippingPartner === "WAYUVEGA" && (
                              <div className="test mt-5">
                                <Select
                                  options={wayuvegaList?.serviceableServices.map(
                                    (val) => {
                                      return {
                                        label: val,
                                        value: val,
                                      };
                                    },
                                  )}
                                  onChange={(val) => {
                                    setWayu(val);
                                  }}
                                />
                              </div>
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>

                      <Col className="gutter-row" xs={24} lg={6}>
                        {" "}
                      </Col>
                    </>
                  )}

                  <Col className="gutter-row" xs={24} lg={18}>
                    <label className="radio">
                      <input
                        type="radio"
                        name="radios2"
                        onChange={(e) => {
                          if (e.target.checked) {
                            setAddclass(true);
                            setFormState({
                              ...formState,
                              externalDeliveryMode: "IN_HOUSE_SERVICE_SERVICE",
                              deliveryMode: "EXTERNAL",
                            });
                          }
                        }}
                      />
                      <span className="mr-5"></span>
                      <p className="m-0">
                        Personalized Delivery Experience with Shipment Via Apni
                        Kheti{" "}
                        <span className="d-block font-size-xs font-weight-normal text-muted">
                          Choose our Shipment Via Apni option for a personalized
                          and efficient delivery experience. Your packages are
                          in good hands.
                        </span>
                      </p>
                    </label>
                  </Col>
                  <Col className="gutter-row" xs={24} lg={6}>
                    {" "}
                  </Col>

                  <Col className="gutter-row" xs={24} lg={18}>
                    <label className="radio">
                      <input
                        type="radio"
                        name="radios2"
                        defaultChecked
                        onChange={(e) => {
                          if (e.target.checked) {
                            setAddclass(false);
                            setFormState({
                              ...formState,
                              deliveryMode: "SELF",
                            });
                          }
                        }}
                      />
                      <span className="mr-5"></span>
                      <p className="m-0">
                        Self ship to the customer{" "}
                        <span className="d-block font-size-xs font-weight-normal text-muted">
                          Please note: Shipping charges will be the same as
                          Courier Service/Shiprocket.
                        </span>
                      </p>
                    </label>
                  </Col>
                </Row>
              </div>
            </div>
          )}

          {/*By Pickrr Start*/}
          <div className="bypickrr">
            {/*Product Packaging Start*/}
            {(OrderStatus === "PICKED_READY_FOR_SHIPPED" ||
              isShipmentCancelled) && (
              <div className="card card-custom mb-5">
                <CardHeader name="Product Packaging" />

                <div className="border-1 border-dark border-top-0 card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-bordered text-center m-0 border radius-remove">
                      <thead>
                        <tr>
                          <th className="align-middle text-left">ITEMS</th>
                          <th className="align-middle">DELIVERY OPTION</th>
                          <th className="align-middle">ORDER STATUS</th>
                          <th className="align-middle" colSpan={3}>
                            ITEM DIMENSIONS
                          </th>
                          <th className="align-middle">ITEM WEIGHT</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.shippingInformation?.productGroup?.map(
                          (dataList, index) => {
                            return (
                              <tr key={index.toString()}>
                                <td className="align-middle">
                                  <div className="d-flex">
                                    <div className="symbol symbol-60 flex-shrink-0 mr-4">
                                      <img
                                        src={
                                          dataList?.productImage
                                            ? dataList?.productImage
                                            : media?.user
                                        }
                                        className="w-100"
                                        alt=""
                                      />
                                    </div>
                                    <div className="d-flex flex-column font-weight-bold text-left">
                                      <span className="">
                                        {dataList?.productName?.en}
                                      </span>
                                      <span className="text-muted">
                                        SKU: {dataList?.sku}
                                      </span>
                                      <span className="text-muted">
                                        Quantity : {dataList?.quantity}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td className="align-middle">
                                  {dataList?.deliveryOption ===
                                  "PICK_UP_FROM_VENDOR"
                                    ? "PICK UP"
                                    : "HOME DELIVERY"}
                                </td>
                                <td className="align-middle">
                                  {dataList?.orderStatus}
                                </td>
                                <td className="align-middle">
                                  <div className="d-flex flex-column">
                                    <span className="font-weight-bold">
                                      Length
                                    </span>
                                    <span className="text-muted">
                                      {dataList?.dimension?.length?.quantity +
                                        " " +
                                        dataList?.dimension?.length?.unit}
                                    </span>
                                  </div>
                                </td>
                                <td className="align-middle">
                                  <div className="d-flex flex-column">
                                    <span className="font-weight-bold">
                                      Width
                                    </span>
                                    <span className="text-muted">
                                      {dataList?.dimension?.width?.quantity +
                                        " " +
                                        dataList?.dimension?.width?.unit}
                                    </span>
                                  </div>
                                </td>
                                <td className="align-middle">
                                  <div className="d-flex flex-column">
                                    <span className="font-weight-bold">
                                      Height
                                    </span>
                                    <span className="text-muted">
                                      {dataList?.dimension?.height?.quantity +
                                        " " +
                                        dataList?.dimension?.height?.unit}
                                    </span>
                                  </div>
                                </td>
                                <td className="align-middle">
                                  <div className="d-flex flex-column">
                                    <span className="text-muted">
                                      {dataList?.dimension?.weight?.quantity +
                                        " " +
                                        dataList?.dimension?.weight?.unit}
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            );
                          },
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="border border-1 border-light-dark border-top-0 card-body font-weight-bolder p-4">
                    <form>
                      <Row gutter={[12, 12]} id="" className="mt-8">
                        <Col className="gutter-row" xs={24}>
                          <p className="font-weight-bolder font-size-lg mb-4 h5">
                            Once your order is packed, please add package weight
                            and dimensions here.
                          </p>
                        </Col>

                        <Col className="gutter-row" xs={24} lg={8}>
                          <ContentInputField
                            name={"Total Package Weight"}
                            onChange={(e) => {
                              setFormState({
                                ...formState,
                                weight: e.target.value,
                              });
                              // setErrors({
                              //   ...errors,
                              //   weight: e.target.value
                              //     ? ""
                              //     : "Weight is Mandatory",
                              // });
                            }}
                            value={formState.weight}
                            // errors={errors?.weight}
                            addonAfter="kg"
                          />
                        </Col>
                        <Col className="gutter-row" xs={24} lg={16}>
                          <label className="font-weight-bolder font-size-sm">
                            Package Dimensions
                          </label>
                          <Row gutter={[12, 12]} id="">
                            <Col className="gutter-row d-flex" xs={18}>
                              <ContentInputField
                                value={formState.height}
                                addonAfter="cm"
                                filter={true}
                                // style={{
                                //   width: "33.3333%",
                                // }}
                                onChange={(e) => {
                                  setFormState({
                                    ...formState,
                                    height: e.target.value,
                                  });
                                  // setErrors({
                                  //   ...errors,
                                  //   height: e.target.value
                                  //     ? ""
                                  //     : "Height is Mandatory",
                                  // });
                                }}
                              />
                              <ContentInputField
                                addonAfter="cm"
                                filter={true}
                                value={formState.breadth}
                                // style={{
                                //   width: "33.3333%",
                                // }}
                                onChange={(e) => {
                                  setFormState({
                                    ...formState,
                                    breadth: e.target.value,
                                  });
                                  // setErrors({
                                  //   ...errors,
                                  //   breadth: e.target.value
                                  //     ? ""
                                  //     : "Breadth is Mandatory",
                                  // });
                                }}
                              />
                              <ContentInputField
                                addonAfter="cm"
                                filter={true}
                                value={formState.width}
                                // style={{
                                //   width: "33.3333%",
                                // }}
                                onChange={(e) => {
                                  setFormState({
                                    ...formState,
                                    width: e.target.value,
                                  });
                                  // setErrors({
                                  //   ...errors,
                                  //   width: e.target.value
                                  //     ? ""
                                  //     : "Width is Mandatory",
                                  // });
                                }}
                              />
                            </Col>
                            <Col className="gutter-row" xs={6}>
                              <button
                                type="button"
                                className="btn btn-dark font-weight-bold letter-spacing btn-sm"
                                onClick={() => {
                                  setFormState({
                                    weight: "",
                                    width: "",
                                    breadth: "",
                                    height: "",
                                  });
                                }}
                              >
                                Reset
                              </button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <div className="my-5 text-center">
                        <button
                          type="submit"
                          className="all_bottom_buttons"
                          onClick={(e) => {
                            e.preventDefault();
                            showRemarks(true);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="all_bottom_buttons"
                          onClick={(e) => {
                            e.preventDefault();

                            if (
                              formState?.weight &&
                              formState?.width &&
                              formState?.height &&
                              formState?.breadth
                            ) {
                              setTimeout(() => {
                                dispatch(
                                  ApproveOrderThunk({
                                    approveOrderRequest: {
                                      ...formState,
                                      deliveryPartner: wayu?.value,
                                      paymentMode: overview?.paymentMethod,
                                    },
                                  }),
                                );
                                setErrors();
                                setCreationLoading(true);
                              }, 100);
                            } else {
                              setErrors({
                                ...errors,
                                weight: formState?.weight
                                  ? ""
                                  : "Weight is Mandatory",
                                width: formState?.width
                                  ? ""
                                  : "Width is Mandatory",
                                height: formState?.height
                                  ? ""
                                  : "Height is Mandatory",
                                breadth: formState?.breadth
                                  ? ""
                                  : "Breadth is Mandatory",
                              });
                            }
                          }}
                        >
                          {creationLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm mr-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Saving...
                            </>
                          ) : (
                            "Save"
                          )}
                        </button>

                        {remarks && (
                          <>
                            <textarea
                              className="border-dark form-control my-5"
                              placeholder="Give reason for cancellation"
                              onChange={(e) => {
                                setCancellationRemark(e.target.value);
                              }}
                            />
                            {cancellationRemark && (
                              <button
                                type="button"
                                className="btn btn-primary mb-2"
                                onClick={() => {
                                  dispatch(
                                    OrderChangeStatusThunk({
                                      orderStatusChangeRequest: {
                                        orderStage: "CANCELLED",
                                        orderRefID: mainOrderId,
                                        remarks: cancellationRemark,
                                      },
                                    }),
                                  );
                                }}
                              >
                                Save
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
            {/*Product Packaging End*/}

            {condition === true && (
              <>
                <div className="card-title m-0">
                  <h5 className="card-label font-weight-bolder">
                    Change Delivery Status
                  </h5>
                </div>
                <div className="my-5">
                  <Select
                    style={{ width: "500px" }}
                    options={[
                      {
                        label: "ACCEPTED",
                        value: "ACCEPTED",
                        isDisabled:
                          OrderStatus === "SHIPPED" ||
                          OrderStatus === "ACCEPTED" ||
                          OrderStatus === "OUT_FOR_DELIVERY" ||
                          OrderStatus === "DELIVERED"
                            ? true
                            : false,
                      },
                      {
                        label: "PICKED_READY_FOR_SHIPPED",
                        value: "PICKED_READY_FOR_SHIPPED",
                        isDisabled:
                          OrderStatus === "SHIPPED" ||
                          OrderStatus === "OUT_FOR_DELIVERY" ||
                          OrderStatus === "DELIVERED"
                            ? true
                            : false,
                      },

                      {
                        label: "DELIVERED",
                        value: "DELIVERED",
                        isDisabled:
                          OrderStatus === "PROCESSING" ||
                          OrderStatus === "ACCEPTED"
                            ? true
                            : false,
                      },
                      {
                        label: "OUT_FOR_DELIVERY",
                        value: "OUT_FOR_DELIVERY",
                        isDisabled:
                          OrderStatus === "PROCESSING" ||
                          OrderStatus === "ACCEPTED"
                            ? true
                            : false,
                      },
                      { label: "CANCELLED", value: "CANCELLED" },
                      { label: "RTO_INITIATED", value: "RTO_INITIATED" },
                      { label: "RTO_IN_TRANSIT", value: "RTO_IN_TRANSIT" },
                      { label: "RTO_DELIVERED", value: "RTO_DELIVERED" },
                      // { label: "DAMAGED", value: "DAMAGED" },
                      // { label: "LOST", value: "LOST" },
                    ]}
                    onChange={(val) => {
                      if (val.value === "CANCELLED") {
                        setPopup(true);
                      } else {
                        dispatch(
                          OrderChangeStatusThunk({
                            orderStatusChangeRequest: {
                              orderStage: val.value,
                              orderRefID: mainOrderId,
                              remarks: "Delivery Status Changed",
                            },
                          }),
                        );

                        setReason("");
                        setPopup(false);
                      }
                    }}
                  ></Select>
                </div>
                {popup && (
                  <>
                    <textarea
                      className="border-dark form-control mb-5"
                      placeholder="Give reason for cancellation"
                      onChange={(e) => {
                        setReason(e.target.value);
                      }}
                    />
                    {reason && (
                      <button
                        type="button"
                        className="btn btn-primary mb-2"
                        onClick={() => {
                          dispatch(
                            OrderChangeStatusThunk({
                              orderStatusChangeRequest: {
                                orderStage: "CANCELLED",
                                orderRefID: mainOrderId,
                                remarks: reason,
                              },
                            }),
                          );
                        }}
                      >
                        Save
                      </button>
                    )}
                  </>
                )}
                <div className="card card-custom mb-5">
                  <CardHeader name="Shipping Information" />
                  <div className="border-1 border-dark border-top-0 card-body p-0">
                    <Row gutter={[12, 12]} id="">
                      <Col className="gutter-row" xs={24}>
                        <div className="table-responsive">
                          <table className="table table-bordered text-center m-0 border radius-remove">
                            <thead>
                              <tr>
                                <th className="align-middle">Product Image</th>
                                <th className="align-middle">Product Name</th>
                                <th className="align-middle">Quantity</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data?.shippingInformation?.productGroup?.map(
                                (dataList, index) => {
                                  return (
                                    <tr>
                                      <td className="align-middle">
                                        <div className="symbol symbol-50 flex-shrink-0 mr-4">
                                          <img
                                            src={
                                              dataList?.productImage
                                                ? dataList?.productImage
                                                : media?.user
                                            }
                                            className="w-100"
                                            alt=""
                                          />
                                        </div>
                                      </td>
                                      <td className="align-middle">
                                        {dataList?.productName?.en}
                                      </td>
                                      <td className="align-middle">
                                        {dataList?.quantity}
                                      </td>
                                    </tr>
                                  );
                                },
                              )}
                            </tbody>
                          </table>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </>
            )}

            {/*Tracking Information Start*/}
            {((OrderStatus === "PACKED" && !isShipmentCancelled) ||
              ((OrderStatus === "SHIPPED" ||
                OrderStatus === "RTO_INITIATED" ||
                OrderStatus === "RTO_IN_TRANSIT" ||
                OrderStatus === "RTO_DELIVERED" ||
                OrderStatus === "DAMAGED" ||
                OrderStatus === "LOST" ||
                OrderStatus === "OUT_FOR_DELIVERY" ||
                OrderStatus === "DELIVERED") &&
                data?.shippingInformation?.externalDeliveryMode ===
                  "IN_HOUSE_SERVICE_SERVICE")) && (
              <div className="card card-custom mb-5">
                <CardHeader name={"Tracking Information"} />
                <div className="border-1 border border-light-dark border-top-0 card-body p-0">
                  {
                    addclass === false ? (
                      // By Store Pickup Start
                      <div className="bystorepickup p-4">
                        {data?.deliveryMode !== "EXTERNAL" && (
                          <Row gutter={[12, 12]}>
                            <Col className="gutter-row" xs={24} lg={8}>
                              <div className="">
                                <ContentInputField
                                  name="Shipping Provider"
                                  onChange={(e) => {
                                    setExternalData({
                                      ...externalData,
                                      shipmentProvider: e.target.value,
                                    });
                                  }}
                                  value={externalData?.shipmentProvider}
                                />
                              </div>
                            </Col>

                            <Col className="gutter-row" xs={24} lg={8}>
                              <div className="">
                                <ContentInputField
                                  name={"Tracking Number"}
                                  onChange={(e) => {
                                    setExternalData({
                                      ...externalData,
                                      trackingId: e.target.value,
                                    });
                                  }}
                                  value={externalData?.trackingId}
                                />
                              </div>
                            </Col>
                          </Row>
                        )}
                        <div className="my-5 text-center">
                          {data?.deliveryMode !== "EXTERNAL" && (
                            <button
                              type="submit"
                              className="all_bottom_buttons"
                              onClick={(e) => {
                                e.preventDefault();
                                dispatch(
                                  OrderChangeStatusThunk({
                                    orderStatusChangeRequest: externalData,
                                  }),
                                );
                              }}
                            >
                              Assign Shipment
                            </button>
                          )}

                          {remarks && (
                            <>
                              <textarea
                                className="border-dark form-control my-5"
                                placeholder="Give reason for cancellation"
                                onChange={(e) => {
                                  setCancellationRemark(e.target.value);
                                }}
                              />
                              {cancellationRemark && (
                                <button
                                  type="button"
                                  className="btn btn-primary mb-2"
                                  onClick={() => {
                                    dispatch(
                                      OrderChangeStatusThunk({
                                        orderStage: "CANCELLED",
                                        orderRefID: mainOrderId,
                                        remarks: cancellationRemark,
                                      }),
                                    );
                                  }}
                                >
                                  Save
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    ) : (
                      // By Store Pickup End
                      // By Pickup Form End
                      <div className="show-only-pickrr">
                        <Row gutter={[12, 12]} id="">
                          <Col className="gutter-row" xs={24}>
                            <div className="table-responsive">
                              <table className="table table-bordered m-0 border radius-remove">
                                <thead className="">
                                  <tr>
                                    <th className="align-middle">
                                      Shipment Type
                                    </th>
                                    <th className="align-middle">
                                      Shipping Provider
                                    </th>
                                    <th className="align-middle">
                                      Date Shipped
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td className="align-middle">Forward</td>
                                    <td className="align-middle">
                                      {data?.shippingInformation
                                        ?.externalDeliveryMode ===
                                      "IN_HOUSE_SERVICE_SERVICE"
                                        ? "Apni Kheti"
                                        : [
                                            ...new Set(
                                              data?.shippingInformation?.productGroup?.map(
                                                (val) =>
                                                  val?.shipmentProvider ===
                                                  "PICKER"
                                                    ? "SHIP_ROCKET"
                                                    : val?.shipmentProvider,
                                              ),
                                            ),
                                          ].join(", ")}
                                    </td>
                                    <td className="align-middle">
                                      {moment
                                        .utc(
                                          data?.shippingInformation
                                            ?.shipmentDate,
                                        )
                                        .local()
                                        .format("DD-MM-YYYY hh:mm A")}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    )
                    // By Pickup Form End*
                  }
                </div>
              </div>
            )}
            {/*Tracking Information End*/}
            {/*Invoice Start*/}
            {![
              "PROCESSING",
              "ACCEPTED",
              "PICKED_READY_FOR_SHIPPED",
              "CANCELLED",
            ].includes(OrderStatus) && (
              <PrintInvoice
                orderRefId={mainOrderId}
                shippingData={data}
                overview={overview}
              />
            )}
            {/*Invoice End*/}
          </div>
          {/*By Pickrr End*/}

          {/* Shipment History */}

          {shippingHistory?.length > 0 &&
            shippingHistory?.some((item) => item?.status !== "ACTIVE") && (
              <ShipmentHistory shipmentHistory={shippingHistory} />
            )}
        </>
      )}
    </>
  );
};
